import { CellContext, ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { Button } from '@valid-eval/shared-react-components';

import * as CommonTableCells from 'components/Tables/CommonTableCells';
import * as CommonTableHeaders from 'components/Tables/CommonTableHeaders';
import { EventUser } from 'data/features/eventsTypes';
import moment from 'moment-timezone';

const columnHelper = createColumnHelper<EventUser>();

const ActionsCell = ({ table, row }: CellContext<EventUser, any>) => {
  const deleteUser = (table.options.meta as any)?.deleteUser;

  return (
    <td className="text-center">
      <Button variant="link" size="sm" onClick={() => deleteUser(row.original)}>
        <i className="fa-solid fa-trash-can m-0"></i>
      </Button>
    </td>
  );
};

export const columns: ColumnDef<EventUser, any>[] = [
  columnHelper.accessor(
    (original) => `${original.lastName + ', ' || ''} ${original.firstName || ''}`,
    {
      id: 'Name',
      header: (props) => <CommonTableHeaders.SortableHeader className="text-left" {...props} />,
      cell: (props) => <CommonTableCells.Text className="text-left" {...props} />,
    },
  ),
  columnHelper.accessor('email', {
    id: 'Email',
    header: (props) => <CommonTableHeaders.SortableHeader className="text-left" {...props} />,
    cell: (props) => <CommonTableCells.SmallText className="text-left" {...props} />,
  }),
  columnHelper.accessor(
    (original) => {
      const createdAt = moment(original.createdAt).tz(moment.tz.guess()).format('MM/DD/YYYY');
      return original.createdAt ? `New (${createdAt})` : 'Cloned';
    },
    {
      id: 'Source',
      header: CommonTableHeaders.SortableHeader,
      cell: CommonTableCells.Text,
    },
  ),
  columnHelper.accessor('id', {
    id: 'Actions',
    header: CommonTableHeaders.SimpleHeader,
    cell: ActionsCell,
  }),
];
